import { Phone, Facebook } from "lucide-react";
import { Link } from "react-router-dom";
import { useHiringStatus } from "@/hooks/useHiringStatus";
import logoAsset from "@/assets/hill-brothers-logo.png.asset.json";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { isHiring } = useHiringStatus();

  return (
    <footer className="bg-foreground text-card py-12">
      <div className="section-container">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="text-center md:text-left">
            <img
              src={logoAsset.url}
              alt="Hill Brothers Painting & Contracting logo"
              width="720"
              height="720"
              loading="lazy"
              decoding="async"
              className="w-44 md:w-52 h-auto mb-3 mx-auto md:mx-0 rounded-xl"
            />
            <p className="text-card/70 text-sm">
              Serving New Hampshire with pride
            </p>
          </div>

          <div className="flex flex-col items-center md:items-end gap-2">
            <div className="flex items-center gap-4">
              <a
                href="tel:+16034244608"
                className="flex items-center gap-2 text-card hover:text-accent transition-colors font-semibold"
              >
                <Phone className="w-4 h-4" aria-hidden="true" />
                603 424 4608
              </a>
              <a
                href="https://www.facebook.com/p/Hill-Brothers-Painting-Contracting-100051497873438/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center w-8 h-8 rounded-full bg-card/10 text-card hover:bg-primary hover:text-primary-foreground transition-colors"
                aria-label="Visit Hill Brothers Painting on Facebook"
              >
                <Facebook className="w-4 h-4" aria-hidden="true" />
              </a>
            </div>
            <p className="text-card/50 text-sm">
              © {currentYear} Hill Brothers Painting & Contracting LLC. All rights reserved.
            </p>
          </div>
        </div>

        <nav className="mt-8 pt-6 border-t border-card/20" aria-label="Footer navigation">
          <ul className="flex flex-wrap items-center justify-center gap-6 text-sm">
            <li>
              <Link to="/#about" className="text-card/70 hover:text-card transition-colors">
                About
              </Link>
            </li>
            <li>
              <Link to="/#services" className="text-card/70 hover:text-card transition-colors">
                Services
              </Link>
            </li>
            <li>
              <Link to="/commercial" className="text-card/70 hover:text-card transition-colors">
                Commercial
              </Link>
            </li>
            <li>
              <Link to="/residential" className="text-card/70 hover:text-card transition-colors">
                Residential
              </Link>
            </li>
            <li>
              <Link to="/#contact" className="text-card/70 hover:text-card transition-colors">
                Contact
              </Link>
            </li>
            {isHiring && (
              <li>
                <Link to="/careers" className="text-card/70 hover:text-card transition-colors">
                  Careers
                </Link>
              </li>
            )}
            <li>
              <Link to="/painters-nashua-nh" className="text-card/70 hover:text-card transition-colors">
                Painters in Nashua NH
              </Link>
            </li>
            <li>
              <Link to="/painters-manchester-nh" className="text-card/70 hover:text-card transition-colors">
                Painters in Manchester NH
              </Link>
            </li>
            <li>
              <Link to="/privacy" className="text-card/70 hover:text-card transition-colors">
                Privacy Policy
              </Link>
            </li>
            <li>
              <Link to="/terms" className="text-card/70 hover:text-card transition-colors">
                Terms of Service
              </Link>
            </li>
            <li>
              <Link to="/admin" className="text-card/70 hover:text-card transition-colors">
                Admin
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </footer>
  );
};

export default Footer;
